<!-- Start Sidemenu Area -->
<div class="sidemenu-area">

    <!-- Start Dialog -->
    <p-dialog [(visible)]="showRegistrationBanner" appendTo="body" [modal]="true" [style]="{width: '50vw', 'border-radius': '20px'}"
        [contentStyle]="{'overflow-y': 'hidden'}"
        [closable]="false" [showHeader]="false" [dismissableMask]="false">
        <div style="padding: 25px; font-size: 15px; line-height: 1.5; color: #333;">
            <h4
                style="color: #d9534f; font-weight: bold; margin-bottom: 15px; border-bottom: 1px solid #eee; padding-bottom: 10px;">
                Important Information</h4>
            <p style="margin-bottom: 10px;"><strong>Dear User,</strong></p>
            <p style="margin-bottom: 15px;">As part of our ongoing system improvements, the Customer Registration Portal is being migrated to a new
                URL. Please review the important dates below and ensure that all pending requests are completed before
                the current portal is decommissioned.</p>
            <h5 style="font-weight: 600; margin-bottom: 10px;">Key Dates:</h5>
            <ul style="list-style-type: disc; padding-left: 20px; margin-bottom: 15px;">
                <li style="margin-bottom: 6px;"><strong>Current Portal Deactivation:</strong> 17 August 2026 at 12:00 AM
                    onwards. Please ensure all open requests are closed before this time.</li>
                <li style="margin-bottom: 6px;"><strong>Portal Shutdown Date:</strong> 17 August 2026</li>
                <li style="margin-bottom: 6px;"><strong>New Portal Login Details:</strong> 17 August 2026. Login
                    credentials and access details for the new portal will be shared on this date.</li>
                <li style="margin-bottom: 6px;"><strong>New Portal Go-Live Date:</strong> 18 August 2026</li>
                <li style="margin-bottom: 6px;"><strong>New Portal URL:</strong> <a
                        href="https://myidexhub.idexasia.com/authentication/side-login" target="_blank"
                        style="color: #007bff; text-decoration: underline;">https://myidexhub.idexasia.com/authentication/side-login</a>
                </li>
            </ul>
            <p style="margin-bottom: 20px; font-weight: 500;">We appreciate your cooperation and support during this
                transition.</p>
            <div style="text-align: right;">
                <button type="button" class="btn btn-secondary"
                    style="padding: 8px 30px; font-weight: 600; border-radius: 5px; cursor: pointer;"
                    (click)="closeBanner()">Close</button>
            </div>
        </div>
    </p-dialog>
    <!-- End Dialog -->

    <div class="sidemenu-header">
        <a routerLink="/dashboard" class="navbar-brand d-flex flex-column">
             <img src="assets/img/main-logo.png" alt="image" >

        </a>
        <div class="responsive-burger-menu d-block d-lg-none">
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
    </div>
    <div class="sidemenu-body">
        <ul class="sidemenu-nav metisMenu h-100" id="sidemenu-nav" data-simplebar>
            <li class="nav-item-title">
                Main
            </li>

            <!-- sidebar for admin and SuperAdmin -->
            <ng-container *ngIf="['Admin','SuperAdmin'].includes(roleName)">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a routerLink="/dashboard" class="nav-link">
                        <span class="icon"><i class='bx bx-home-circle'></i></span>
                        <span class="menu-title">Dashboard</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Masters</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/linkGeneration" class="nav-link">
                                <span class="icon"><i class='bx bx-plus-circle'></i></span>
                                <span class="menu-title">Link Generation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-link-generation')" class="nav-link">
                                <span class="icon"><i class='bx bx-plus-circle'></i></span>
                                <span class="menu-title">Customer Link Generation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/itemMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Part Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/costBreakup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Cost Breakup Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/payment-terms" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Payment Terms Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/manufacturingProcessList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">manufacturing Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/materialConstructionList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Material of Construction Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/othercategorymaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Other Category Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/buMaster" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">BU Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/bussinessUnitNumber" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Bussiness Unit Number Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/materialGrade" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Material Grade Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/materialForm" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Material Form Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/supplierdocumentMaster" class="nav-link"
                                routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Doc Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" (click)="showBanner('/documentMaster')" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Doc Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" (click)="showBanner('/customerBuMaster')" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer BU Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="javascript:void(0)" (click)="showBanner('/branchPlant')" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Branch Plant Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/part-drawing" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Part Drawing Master</span>
                            </a>
                        </li>
                          <li class="nav-item">
                            <a routerLink="/value-stream" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Value Stream Master</span>
                            </a>
                        </li>
                          <li class="nav-item">
                            <a routerLink="/tds-master" class="nav-link" routerLinkActive="active mm-active">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tds Master</span>
                            </a>
                        </li>
                    </ul>
                </li>


                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierUploadedDocList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Documents</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierChangeRequestLogs" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Change Request</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplier-upload-doc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Upload Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplier-audit-logs" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Audit Logs</span>
                            </a>
                        </li>
                          <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/msme-list" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Msme-List</span>
                            </a>
                        </li>
                      
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">PPAP APQP Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/apqpDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Document</span>
                            </a>
                        </li>
                         <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/apqp-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Listing</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/ppapDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Document</span>
                            </a>
                        </li>
                          <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/ppap-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Listing</span>
                            </a>
                        </li>
                    </ul>
                </li>
                
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Tool Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/toolLoanAgreement" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Loan Agreement</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/toolhealthcheckup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Health Checkup</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/tool-shifting-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Shifting Form</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">RFQ Screens</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/requestForQuotation" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Request For Quotation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierAssignList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Assign List</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierDashboard" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">RFQ Reply</span>
                            </a>
                        </li>

                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/openEnquiry"
                                (click)="reloadPage('/enquiryPurchase/openEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open Enquiry Comparison</span>
                            </a>
                        </li>
                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/closeEnquiry"
                                (click)="reloadPage('/enquiryPurchase/closeEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Closed Enquiry Comparison</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">User</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/userRegistration" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Register User</span>
                            </a>
                        </li>
                          <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/checker-assign" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Assign Checker</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/generated-asn" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">ASN List</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" (click)="showBanner()" class="nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Customer</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-list')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-upload-doc')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Upload Doc</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-audit-logs')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Audit Logs</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customerChangeRequestLogs')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Change Request</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/order-status" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Order Status</span>
                            </a>
                        </li> -->
                    </ul>
                </li>
            </ng-container>


            <!-- sidebar for Customer -->
            <ng-container *ngIf="roleName == 'Customer'">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" (click)="showBanner()" class="nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Customer</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-edit-form')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Form</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-upload-doc')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Upload Doc</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customerRaiseChangeRequest')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Raise Request</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/order-status" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Order Status</span>
                            </a>
                        </li> -->
                    </ul>
                </li>
            </ng-container>

            <!-- sidemenu for user -->
            <ng-container *ngIf="roleName == 'User' || roleName == 'Normal User'">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Masters</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/linkGeneration" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Link Generation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/itemMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Part Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/costBreakup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Cost Breakup Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierdocumentMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Doc Master</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link"
                        routerLinkActive="active mm-active">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierUploadedDocList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Documents</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierChangeRequests" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Change Approval</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker2">
                            <a routerLink="/assessmentDoc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Assessment Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active"
                            *ngIf="userRole.checker2 || userRole.checker1">
                            <a routerLink="/supplier-upload-doc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Upload Supplier Document</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level" >
                        <li class="nav-item" routerLinkActive="active mm-active" >
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/generated-asn" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">ASN List</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">RFQ</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/requestForQuotation" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Request For Quotation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierAssignList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Assign List</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierDashboard" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">RFQ Reply</span>
                            </a>
                        </li>

                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/openEnquiry"
                                (click)="reloadPage('/enquiryPurchase/openEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open Enquiry Comparison</span>
                            </a>
                        </li>
                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/closeEnquiry"
                                (click)="reloadPage('/enquiryPurchase/closeEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Closed Enquiry Comparison</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">PPAP APQP Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/apqpDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Document</span>
                            </a>
                        </li>
                         <li class="nav-item" routerLinkActive="active mm-active"  *ngIf="userRole.checker1||userRole.checker2">
                            <a routerLink="/apqp-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Listing</span>
                            </a>
                        </li>
                        
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/ppapDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Document</span>
                            </a>
                        </li>
                          <li class="nav-item" routerLinkActive="active mm-active"  *ngIf="userRole.checker1||userRole.checker2">
                            <a routerLink="/ppap-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Listing</span>
                            </a>
                        </li>
                    </ul>
                </li>
                
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Tool Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1||userRole.checker2">
                            <a routerLink="/toolLoanAgreement" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Loan Agreement</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active"*ngIf="roleName == 'Supplier' || 'Admin' ||userRole.checker1">
                            <a routerLink="/toolhealthcheckup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Health Checkup</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active"  *ngIf="userRole.checker1||userRole.checker2">
                            <a routerLink="/tool-shifting-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Shifting Form</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>

            <!-- sidemenu for finance -->
            <ng-container *ngIf="['Finance','Global Sourcing'].includes(roleName)">
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Masters</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/linkGeneration" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Link Generation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/itemMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Part Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/costBreakup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Cost Breakup Master</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/supplierdocumentMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Document Master</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier List</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierUploadedDocList" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Supplier Documents</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierChangeRequests" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Supplier Change Request</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker2">
                            <a routerLink="/assessmentDoc" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Assessment Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker2">
                            <a routerLink="/supplier-upload-doc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Upload Supplier Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplier-audit-logs" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Audit Logs</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'
                                ></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/generated-asn" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">ASN List</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" (click)="showBanner()" class="nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Customer</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-audit-logs')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Audit Logs</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/f" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Order Status</span>
                            </a>
                        </li> -->
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">RFQ</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/requestForQuotation" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Request For Quotation</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierAssignList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Assign List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierDashboard" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">RFQ Reply</span>
                            </a>
                        </li>

                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/openEnquiry"
                                (click)="reloadPage('/enquiryPurchase/openEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open Enquiry Comparison</span>
                            </a>
                        </li>
                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/closeEnquiry"
                                (click)="reloadPage('/enquiryPurchase/closeEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Closed Enquiry Comparison</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">PPAP APQP Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/apqpDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Document</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/ppapDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Document</span>
                            </a>
                        </li>
                    </ul>
                </li>
                
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Tool Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/toolLoanAgreement" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Loan Agreement</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/toolhealthcheckup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Health Checkup</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/tool-shifting-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Shifting Form</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>

            <!-- sidemenu for Customer Cs Team Finance Team Approval Team -->
            <ng-container
                *ngIf="roleName == 'CS Team' || roleName == 'Finance-JDE' || roleName == 'Customer-JDE' || roleName == 'Customer-Approval'">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" (click)="showBanner()" class="nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Customer</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-link-generation')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Link Generation</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customerRaiseChangeRequest')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Raise Request</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-list')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-upload-doc')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Upload Doc</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/documentMaster')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Doc Master</span>
                            </a>
                        </li> -->

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/customerRaiseChangeRequestList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Change Approval</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customer-audit-logs')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Audit Logs</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a href="javascript:void(0)" (click)="showBanner('/customerChangeRequestLogs')" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Customer Changes Logs</span>
                            </a>
                        </li>
                        <!-- <li class="nav-item" routerLinkActive="active mm-active" *ngIf="roleName == 'CS Team' || roleName == 'Finance' || roleName == 'Customer-Approval'">
                            <a routerLink="/order-status" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Order Status</span>
                            </a>
                        </li> -->
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/generated-asn" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">ASN List</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="roleName !== 'Finance-JDE'">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="roleName == 'Finance-JDE'">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplier-audit-logs" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Audit Logs</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>


            <!-- sidemenu for bussiness head -->
            <ng-container *ngIf="roleName=='Bussiness head'">
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Masters</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/linkGeneration" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Link Generation</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/itemMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Part Master</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/costBreakup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Cost Breakup Master</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier List</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierUploadedDocList" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Supplier Documents</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierChangeRequests" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Supplier Change Request</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker2">
                            <a routerLink="/assessmentDoc" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Assessment Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active"
                            *ngIf="userRole.checker2 || userRole.checker1">
                            <a routerLink="/supplier-upload-doc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Upload Supplier Document</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                            <a routerLink="/supplier-audit-logs" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Audit Logs</span>
                            </a>
                        </li>
                    </ul>
                </li>
                  <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">PPAP APQP Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                            <a routerLink="/apqpDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Document</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                            <a routerLink="/ppapDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Document</span>
                            </a>
                        </li>
                    </ul>
                </li>
                
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Tool Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                            <a routerLink="/toolLoanAgreement" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Loan Agreement</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level"   >
                        <li class="nav-item" routerLinkActive="active mm-active" >
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/generated-asn" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">ASN List</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">RFQ</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/requestForQuotation" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Request For Quotation</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierAssignList" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier Assign List</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1">
                            <a routerLink="/supplierDashboard" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">RFQ Reply</span>
                            </a>
                        </li>

                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/openEnquiry"
                                (click)="reloadPage('/enquiryPurchase/openEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open Enquiry Comparison</span>
                            </a>
                        </li>
                        <li class="nav-item" style="cursor: pointer;" routerLinkActive="active mm-active">
                            <a class="nav-link" routerLink="/enquiryPurchase/closeEnquiry"
                                (click)="reloadPage('/enquiryPurchase/closeEnquiry')">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Closed Enquiry Comparison</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active" *ngIf="userRole.checker1 || userRole.checker2">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>

            <!-- sidebar for supplier -->
            <ng-container *ngIf="roleName == 'Supplier'">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a routerLink="/supplierDashboard" class="nav-link">
                        <span class="icon"><i class='bx bx-wallet'></i></span>
                        <span class="menu-title">Supplier Dashboard</span>
                    </a>
                </li>

                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Supplier Master</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierMaster" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Supplier List</span>
                            </a>
                        </li>

                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplierOnboarding" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Supplier Onboarding</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/raiseChangeRequest" class="nav-link">
                                <span class="icon"><i class='bx bx-copy'></i></span>
                                <span class="menu-title">Raise Change Request</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/supplier-upload-doc" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Upload Supplier Document</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!-- <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Order Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/myOrders" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Orders Details</span>
                            </a>
                        </li>   
                    </ul>
                </li>
                 -->
                 <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li>
                            <li class="nav-item" routerLinkActive="active mm-active">
                                <a routerLink="/generated-asn" class="nav-link">
                                    <span class="icon"><i class='bx bx-wallet'></i></span>
                                    <span class="menu-title">ASN List</span>
                                </a>
                            </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">PPAP APQP Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/apqpDocument" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP</span>
                            </a>
                        </li> -->
                           <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/apqp-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">APQP Listing</span>
                            </a>
                        </li>
                        

                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/PPAP" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP</span>
                            </a>
                        </li> -->
                          <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/ppap-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">PPAP Listing</span>
                            </a>
                        </li>
                    </ul>
                </li>
                
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Tool Related</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/toolLoanAgreement" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Loan Agreement</span>
                            </a>
                        </li>
                        <li class="nav-item" routerLinkActive="active mm-active" >
                            <a routerLink="/toolhealthcheckup" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Health Checkup</span>
                            </a>
                        </li>
                          <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/tool-shifting-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Tool Shifting Form</span>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Reports</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/report" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Reports</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ng-container>

            <ng-container *ngIf="roleName=='Store'">
                <li class="nav-item" routerLinkActive="active mm-active">
                    <a href="javascript:void(0)" class="collapsed-nav-link nav-link">
                        <span class="icon"><i class='bx bx-layer'></i></span>
                        <span class="menu-title">Purchase Details</span>
                    </a>
                    <ul class="sidemenu-nav-second-level">
                        <!-- <li class="nav-item" routerLinkActive="active mm-active">
                            <a routerLink="/jde-data-listing" class="nav-link">
                                <span class="icon"><i class='bx bx-wallet'></i></span>
                                <span class="menu-title">Open PO Details</span>
                            </a>
                        </li> -->
                            <li class="nav-item" routerLinkActive="active mm-active">
                                <a routerLink="/generated-asn" class="nav-link">
                                    <span class="icon"><i class='bx bx-wallet'></i></span>
                                    <span class="menu-title">ASN List</span>
                                </a>
                            </li>
                    </ul>
                </li>
            </ng-container>

            <li class="nav-item" routerLinkActive="active mm-active">
                <a (click)="logOut()" class="nav-link" routerLinkActive="active mm-active" style="cursor: pointer;">
                    <span class="icon"><i class='bx bx-log-out'></i></span>
                    <span class="menu-title">Logout</span>
                </a>
            </li>
        </ul>
    </div>
     <div class="sidebar-footer">
    <a routerLink="/dashboard" class="navbar-brand d-flex flex-column">
      <img
        src="assets/img/iapp3.svg"
        alt="image"
        style="width: 100px ;margin-left:- 20px"
      />
    </a>
</div>
</div>
<!-- End Sidemenu Area -->